import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost
} from "./_wsApiFetchData";

export async function searchPaymentMethods(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    paymentMethodId,
    userId,
    displayName,
    isDefault,
    status,
    beforeAt,
    afterAt
  } = filters;

  const params = {
    Page: skipPages || 1,
    Elements: resultsCount,
    PaymentMethodId: paymentMethodId || undefined,
    UserId: userId || undefined,
    DisplayName: displayName || undefined,
    Status: status || undefined,
    IsDefault: isDefault == 'true' ? true : undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined
  };

  return toPascal(await wsRequestPost('/admin/paymentmethods/search', language, timeZone, params, null, cancelToken));
}

export async function getPaymentMethodUndefined(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/paymentmethods/${id}`, language, timeZone, null, cancelToken));
}

export async function getCreditCard(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/paymentmethods/${id}`, language, timeZone, null, cancelToken));
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
